import { LineChart, Line, CartesianGrid, XAxis, YAxis } from 'recharts';
import React from "react";
const data = [
    {name: 'A', uv: 741, amt: 10},
    {name: 'B', uv: 733, amt: 10},
    {name: 'C', uv: 727, amt: 10},
    {name: 'D', uv: 731, amt: 10},
];

class FlameGraph extends React.Component {
    render() {
        return (
            <LineChart width={160} height={150} data={data}>
                <Line type="monotone" dataKey="uv" stroke="#FF84d8" strokeWidth="5"/>
                <CartesianGrid stroke="#ccc" />
                <XAxis label="Flame" dy={50}/>
                <YAxis />
            </LineChart>
        );
    }
}

export default FlameGraph;
